/* eslint-disable no-unused-expressions */
import React, { useEffect, Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Select, Tag, Space,
} from 'antd';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import { GetPurchaseIndentList } from '../../../../../modules/purchase/purchaseIndent';
import CFV2Actions from '@Actions/configurations/cfV2Actions';

function PurchaseIndents({
  purchaseIndent, getPILoading, getPurchaseIndent, mrpData, call, customFieldsProps,
}) {
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-pi') ? JSON.parse(localStorage.getItem('prcz-page-columns-pi')) : {
    PI_NUMBER: {
      label: 'PI #',
      visible: true,
    },
    LOCATION: {
      label: 'LOCATION',
      visible: true,
    },
    ITEMS: {
      label: 'Item(S)',
      visible: true,
    },
    DATE: {
      label: 'Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    LABEL: {
      label: 'Label',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });
  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];
  const getPurchaseRequestColumns = () => {
    const purchaseRequestColumns = [
      {
        title: '',
        render: (record) => (
          <Link to={`/purchase/purchase-indent/view/${record?.pi_id}`}>
            <div className="mobile-list__item">
              <div style={{ display: 'flex' }}>
                <H3Text text={`#${record?.pi_number}`} className="mobile-list__item-number" />
                <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
                  {Helpers.getStatusColor(record?.status)?.text?.toUpperCase()}
                </div>
              </div>
              <div className="mobile-list__item-info">
                <H3Text text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_alias_name})`} />
              </div>
              <H3Text text={`PI Date - ${toISTDate(record?.pi_date).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />
              <H3Text text={`Planning Number = ${record?.planning_number}`} className="mobile-list__item-info" />
              <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
            </div>
          </Link>
        ),
        responsive: ['xs'],
      },
      {
        title: 'PI #',
        dataIndex: 'pi_number',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.PI_NUMBER?.visible ? 'display-none' : '',

      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div>
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_alias_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',

      },
      {
        title: 'ITEM(S)',
        render: (text, record) => record.lines_count,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'PURCHASE INDENT DATE',
        render: (text, record) => dayjs(record?.pi_date).format('DD/MM/YYYY'),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.DATE?.visible ? 'display-none' : '',

      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}>
            {Helpers.getStatusColor(item?.status)?.text}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',

      },
      {
        title: 'LABELS',
        render: (item) => (
          <Fragment>
            <div className="table-labels__list">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
      {
        title: '',
        render: (record) => (
          <div
            className="list__actions"
            style={{ justifyContent: 'end' }}
          >
            <div
              className="list__actions-button list__actions-button-dark"
              style={{ width: '70px', whiteSpace: 'nowrap' }}
              onClick={() => {
                window.open(`/purchase/purchase-indent/view/${record?.pi_id}`);
              }}
            >
              View
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: 'list__actions-column',

      },
    ];
    return purchaseRequestColumns;
  };

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-pi'))?.[customField.cf_id]?.visible || false,
        };
      });

      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  useEffect(() => {

    if (mrpData) {
      getPurchaseIndent({
        query: {
          tenant_id: mrpData?.tenant_id,
          mrp_id: mrpData?.mrp_id,
        },
      });
    }
  }, [call, mrpData]);

  const getDataSource = (data) => {
    if (data) {
      const copyData = [];
      for (let i = 0; i < data?.length; i++) {
        copyData.push({
          ...data?.[i],
          key: data?.[i]?.pi_id,
        });
      }
      return copyData;
    }
    return [];
  };

  return (
    <Fragment>
      <div className="purchase-request__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="generic-table-container">
              <Table
                title={() => (
                  <React.Fragment>
                    <div style={{ display: 'flex' }}>
                      {`${(purchaseIndent && purchaseIndent?.count) ? purchaseIndent?.count : '0'} Purchase Indents`}
                    </div>
                  </React.Fragment>
                )}
                bordered
                loading={getPILoading}
                showHeader
                size="small"
                scroll={{ x: 'max-content' }}
                columns={getPurchaseRequestColumns()}
                dataSource={getDataSource(purchaseIndent?.purchase_indents) || []}
                pagination={false}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, CFV2Reducers, GetPurchaseIndentList,
}) => ({
  user: UserReducers.user,
  customFieldsProps: CFV2Reducers.cfV2DocPurchaseRequest,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  purchaseIndent: GetPurchaseIndentList.data,
  getPILoading: GetPurchaseIndentList.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseIndent: (payload, callback) => dispatch(GetPurchaseIndentList.actions.request(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseIndents));
